import { Card, CardBody, Col, Form, FormGroup, Input, Label, Modal, ModalBody, ModalHeader, Row, Table } from 'reactstrap';
import { InvoicingDetailDto } from '../../types';
import React, { useState } from 'react';

import { Button } from '../../components';
import AdministrativeFeesForm from '../system-admin/invoice/AdministrativeFeesForm';
import { invoiceService } from '../../services/InvoiceService';
import { toast } from 'react-toastify';
import { useForm, Controller } from 'react-hook-form';
import { generateYears } from '../../common/Utils';
import UnpaidInvoicesTable from './UnpaidInvoicesTable';

const Unpaid = () => {
    const currentYear = new Date().getFullYear().toString();
    const [invoices, setInvoices] = useState<InvoicingDetailDto[]>();
    const [fiscalYear, setFiscalYear] = useState<string>(currentYear);
    const [applyingLateFees, setApplyingLateFees] = useState(false);
    const { control, handleSubmit } = useForm({
        defaultValues: {
            fiscalYear: currentYear
        }
    });
    const [, setReload] = useState<boolean>(false);

    const onSubmit = () => {
        const toastId = toast.info('Searching...', {
            autoClose: false,
        });
        invoiceService
            .getUnpaidInvoices(fiscalYear || '')
            .then((response) => {
                setInvoices(response);
                toast.update(toastId, {
                    type: 'success',
                    autoClose: 500,
                    closeOnClick: true,
                    draggable: true,
                });
            })
            .catch(() => toast.error('Failed to get unpaid invoices'));
    };

    const exportReport = () => {
        const toastId = toast.info('Generating unpaid invoice report, this may take a minute...', {
            autoClose: false,
        });

        invoiceService
            .getUnpaidInvoiceReportExport(fiscalYear || '')
            .then((response) => {
                const downloadLink = window.document.createElement('a');
                downloadLink.href = window.URL.createObjectURL(
                    new Blob([response], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' }),
                );
                downloadLink.download = 'Unpaid Invoice Report.xlsx';
                document.body.appendChild(downloadLink);
                downloadLink.click();
                document.body.removeChild(downloadLink);
                toast.update(toastId, {
                    render: 'Unpaid Invoice report generated successfully.',
                    type: 'success',
                    autoClose: 2500,
                    closeOnClick: true,
                    draggable: true,
                });
            })
            .catch(() => toast.error('Failed to export report'));
    };

    const reloadInvoices = () => {
        setInvoices(undefined);
        setReload(true);
    };

    return (
        <>
            <Card>
                <CardBody>
                    <div className="d-flex align-items-center mb-4" style={{ gap: '1rem' }}>
                        <h3 className="mb-0 mt-1">Unpaid Invoices</h3>
                        <div className="flex-grow-1"></div>
                        <Button color="link" onClick={() => setApplyingLateFees(true)}>
                            Apply Administrative Fees
                        </Button>
                        <Button color="info" onClick={() => exportReport()}>
                            Export Report
                        </Button>
                    </div>
                    <Row>
                        <Col>
                            <Form noValidate onSubmit={handleSubmit(onSubmit)} className="d-flex align-items-center flex-wrap" style={{ gap: '1rem' }}>
                                <div className="d-flex align-items-center" style={{ gap: '0.5rem' }}>
                                    <Label for="fiscalYear" className="mb-0" style={{ whiteSpace: 'nowrap' }}>
                                        Fiscal Year
                                    </Label>
                                    <Controller
                                        name="fiscalYear"
                                        control={control}
                                        render={({ field }) => (
                                            <Input
                                                {...field}
                                                type="select"
                                                value={field.value ?? currentYear}
                                                onChange={(e) => {
                                                    field.onChange(e);
                                                    setFiscalYear(e.target.value);
                                                }}
                                            >
                                                <option value="">Select Year</option>
                                                {generateYears().map((ct) => (
                                                    <option key={ct} value={ct}>
                                                        {ct}
                                                    </option>
                                                ))}
                                            </Input>
                                        )}
                                    />
                                </div>
                                <div>
                                    <Button type="submit">Search</Button>
                                </div>
                            </Form>
                        </Col>
                    </Row>
                </CardBody>
                {invoices && (
                    <div>
                        <div className="ml-3">
                            <h5>Total: {invoices.length}</h5>
                        </div>
                        <UnpaidInvoicesTable invoices={invoices} onSave={() => reloadInvoices()} />
                    </div>
                )}
                {!invoices && (
                    <Table>
                        <tbody>
                            <tr></tr>
                        </tbody>
                    </Table>
                )}
            </Card>

            <Modal isOpen={applyingLateFees} toggle={() => setApplyingLateFees(!applyingLateFees)} size="lg">
                <ModalHeader toggle={() => setApplyingLateFees(!applyingLateFees)}>
                    Apply Administrative Fees
                </ModalHeader>
                <ModalBody>
                    <AdministrativeFeesForm
                        onSave={() => {
                            setApplyingLateFees(false);
                        }}
                        onCancel={() => setApplyingLateFees(false)}
                    />
                </ModalBody>
            </Modal>
        </>
    );
};

export default Unpaid;
